import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from '../../base_link/component';
import { Col } from '../../util_grid/grid.js';

import './styles/styles.scss';


/**
 * The ankeiler Text is a variant of ankeiler (component).
 * You can render a ankeiler with variant = text and it will render this component
 *
 * It should be rendered inside a grid.
 *
 * This variant shows a tile with some introduction text.
 *
 */
class AnkeilerText extends Component {
  get name() {
    return this.props.name || '';
  }

  get text() {
    return this.props.text || '';
  }

  get url() {
    return this.props.url || false;
  }

  get linkTitle() {
    return this.props.linkTitle || (this.url ? 'lees meer' : '');
  }

  render() {
    return (
      <Col xs={this.props.xs || 6} sm={this.props.sm || 4} md={this.props.md || 3} className="ankeiler ankeiler-text">
        <div className="ankeiler-container">
          <h4>{this.name}</h4>
          <p>{this.text}</p>

          {!!this.url &&
            <Link className="author-link" href={this.url}>
              {this.linkTitle}
            </Link>
          }
        </div>
      </Col>
    );
  }
}


AnkeilerText.propTypes = {
  /**
   * The name or title that is show above the text
   */
  name: PropTypes.string,
  /**
   * The text that needs to be displayed
   */
  text: PropTypes.string,
  /**
   * The url where to link to
   */
  url: PropTypes.string,
  /**
   * The title of the link
   */
  linkTitle: PropTypes.string,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
};


export default AnkeilerText;
